import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import '../styles/componentStyles/Journal.css';

function Journal(props) {
  const { t } = useTranslation();
  const [text, setText] = useState();
  const savedText = props.data?.[props.questionid];

  useEffect(() => {
    if (savedText) {
      setText(savedText);
    } else {
      setText('');
    }
  }, [savedText]);

  const handleChange = (e) => {
    props.saveResponse('journal', {
      id: props.questionid,
      value: e.target.value,
    });
  };

  return (
    <>
      {' '}
      <div className="tracker-content-heading">
        <h2 id="journal-heading" className="title">
          {t('T018')}
        </h2>
        <p className="optional-text">{t('T019')}</p>
      </div>
      <textarea
        id="journal-textarea"
        aria-labelledby="journal-heading"
        className={`${props.alcohol ? 'journal-input alc' : 'journal-input'} fs-mask`}
        placeholder={props.placeholder}
        // maxLength="650"
        onChange={handleChange}
        value={text}
      />
    </>
  );
}
export default Journal;
